<div class="d-flex align-items-center">
    <span>
        {{(params.value || 0) | currency}}
    </span>
    
    <span  class="ppc-card_box--badge hand" [matMenuTriggerFor]="netProfitDialog" (click)="openDialog()">
        <svg width="6.34" height="6.34" class="mr-1">
            <use xlink:href="assets/images/sprite-icons.svg#bar-chart-icon"></use>
        </svg> P&L 
    </span>
</div>

<mat-menu #netProfitDialog="matMenu" xPosition="before" class="netProfitDialog">  
        <div class="item" *ngIf="!params.type && !analyticsBreakdownData?.length">
            <ng-container *ngIf="data">
            <div class="item_group"> 
                <span class="item_value">Sales</span>
                <span class="item_value">{{(data.Sales || 0) | currency}}</span>
            </div>
            <div class="item_group"> 
                <span class="item_value">COGS</span>
                <span class="item_value">{{(data.Cogs || 0) | currency}}</span>
            </div>
            <div class="item_group"> 
                <span class="item_value">Selling Fees</span>
                <span class="item_value">{{(data.CommissionFees? data.CommissionFees: data.SellingFees  || 0) | currency}}</span>
            </div>
            <div class="item_group"> 
                <span class="item_value">Fulfillment Fees</span>
                <span class="item_value">{{(data.FulfillmentFees   || 0) | currency}}</span>
            </div>
            <div class="item_group"> 
                <span class="item_value">Shipping</span>
                <span class="item_value">{{(data.Shipping || 0) | currency}}</span>
            </div>
            <div class="item_group"> 
                <span class="item_value">Promotions</span>
                <span class="item_value">{{(data.Promotions || 0) | currency}} </span>
            </div>
            <div class="item_group"> 
                <span class="item_value">Refunds</span>
                <span class="item_value">{{(data.Refunds || 0) | currency}} </span>
            </div>
            <div class="item_group"> 
                <span class="item_value">Other</span>
                <span class="item_value">{{(data.Other || 0) | currency}}</span>
            </div>
            <div class="item_group"> 
                <span class="item_value">Misc</span>
                <span class="item_value">{{(data.Misc || 0) | currency}}</span>
            </div>
            <div class="item_group"> 
                <span class="item_value">Storage Fees</span>
                <span class="item_value">{{(data.StorageFees || 0) | currency}}</span>
            </div>
            <div class="item_group" *ngIf="params.isShowPpcSpend"> 
                <span class="item_value">PPC Spend</span>
                <span class="item_value">{{(data.PpcSpend ? data.PpcSpend : data.PpcCost  || 0) | currency}}</span>
            </div>
            <div class="item_group item_footer border-top pt-1 mt-2"> 
                <span class="item_value">Total Profit</span>
                <span class="item_value">{{((data.Sales || 0) + (data.Cogs || 0) + (data.CommissionFees || 0) + (data.FulfillmentFees || 0) + (data.SellingFees || 0)+ (data.Shipping || 0) + (data.Promotions || 0) + (data.Refunds || 0)  + (data.Other|| 0 ) + (data.Misc|| 0 )+ (data.StorageFees|| 0 ))+ (params.isShowPpcSpend ? data.PpcSpend || 0 : 0) + (params.isShowPpcSpend ? data.PpcCost || 0 : 0)  | currency}}</span>
            </div>
        </ng-container>
        </div>
        <div  class="item" *ngIf="(params.type) && (analyticsBreakdownData?.length) && (!loader)">
            <div class="item_group item_groupMisc" *ngFor="let item of analyticsBreakdownData"> 
                <span class="item_value">{{item.description}}</span>
                <span class="item_value">{{(item.amount || 0) | currency}}</span>
            </div>
            <div class="item_group item_footer border-top pt-1 mt-2"> 
                <span class="item_value">Total Profit</span>
                <span class="item_value">{{(totalProfit || 0) | currency}}</span>
            </div>
        </div>
        <div class="list_popup" *ngIf="(!analyticsBreakdownData?.length || loader) && params.type">
            <app-no-results
            [message]="loader && params.type ? 'Loading ' : 'No Data found'"
          ></app-no-results>
        </div>
  </mat-menu>
